export default "__VITE_ASSET__DhDqq9gm__"